import React, { Component } from 'react';
import './style.scss';

class Loader extends Component {

  render() {
    return (
      <div className="loading">
        <div className="loading-inner--loader" style={{ width: `${40}px`, height: `${40}px`, animation: `spin ${2}s linear infinite` }} />
      </div>
    );
  }
}

export default Loader;
